// Added officially in Next 14.1
import TrueMedLogo from '@public/logos/truemed_logo_white.svg';
import HSABackground from '@public/pricing/hsa-bg-desktop.webp';
import HSABackgroundMobile from '@public/pricing/hsa-bg-mobile.webp';
import Image, { unstable_getImgProps as getImageProps } from 'next/image';

const PricingTrueMedSection = () => {
  const common = {
    alt: 'blurred image of a person working out',
    sizes: '100vw',
  };

  const {
    props: { srcSet: desktop },
  } = getImageProps({
    ...common,
    quality: 70,
    src: HSABackground,
  });
  const {
    props: { srcSet: mobile, ...rest },
  } = getImageProps({
    ...common,
    quality: 70,
    src: HSABackgroundMobile,
  });

  return (
    <section className="flex flex-col items-center justify-center h-[300px] relative overflow-hidden">
      <div className="absolute inset-0 -m-4">
        <picture className="w-full h-full" draggable={false}>
          <source media="(min-width: 768px)" srcSet={desktop} />
          <source media="(max-width: 767px)" srcSet={mobile} />
          <img {...rest} alt={common.alt} className="w-full h-full object-cover blur-lg" />
        </picture>
      </div>
      <div className="flex flex-col gap-6 px-20 text-center items-center font-light">
        <h2 className="text-alter-gray-60 text-[28px] lg:text-[42px] font-light relative z-10">
          Alter is HSA/FSA Eligible
        </h2>
        <p className="text-lg relative z-10 text-[#fffcf4cc]">
          Powered by
          <span>
            <Image src={TrueMedLogo} className="inline pl-2" alt="TrueMed Logo" />
          </span>
        </p>
      </div>
    </section>
  );
};

export default PricingTrueMedSection;
